import { EntityType, MaybeId } from 'api'
import { useSelector } from 'react-redux'
import { authorisedUserSelector } from 'selectors/connectionSelectors'
import { createEntitySelector } from 'selectors/entitySelectors'
import { userPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { isAdminGatewayUserSelector } from 'selectors/userSelectors'
import { identityPropsSelector, useParametricSelector } from 'utils'

const userSelector = createEntitySelector(identityPropsSelector, EntityType.USER)
export const useUser = (id: MaybeId) => useParametricSelector(userSelector, id)

export const useAuthorisedUser = () => useSelector(authorisedUserSelector)
export const useUserPreference = () => useSelector(userPreferenceSelector)
export const useIsAdmin = () => useSelector(isAdminGatewayUserSelector)
